import { LetterTypes } from './LetterTypes';
import { CheckEmptyOrWhitespace } from '@/Shared/Validator';
import { Hearing } from './Hearing';

export class HearingInfo {
    public hearing: Hearing = new Hearing();
    public hearingLetterType: number | null = 0;
    public hearingLetterList: LetterTypes[] | null = null;
}

export function PrepareHearing(hearing: HearingInfo): HearingInfo {
    let newHearing: HearingInfo = new HearingInfo();
    newHearing = hearing;

    if (newHearing.hasOwnProperty('hearing')) {

        if (newHearing.hearing.hasOwnProperty('hearingDate')
        && !CheckEmptyOrWhitespace(newHearing.hearing.hearingDate, 'date')) {
            if (newHearing.hearing.hearingDate != null) {
                const str = newHearing.hearing.hearingDate.toString();
                const arr = str.split('T');
                if (arr.length > 1) {
                    newHearing.hearing.hearingDateStr = new Date(arr[0]);
                    newHearing.hearing.hearingTimeStr = arr[1];
                } else {
                    newHearing.hearing.hearingDateStr = new Date(str.replace('T', ' '));
                    newHearing.hearing.hearingTimeStr = new Date(str.replace('T', ' ')).toLocaleDateString();
                    newHearing.hearing.hearingTimeStr = newHearing.hearing.hearingTimeStr.replace(' AM', '');
                    newHearing.hearing.hearingTimeStr = newHearing.hearing.hearingTimeStr.replace(' PM', '');
                }
            }
        }

        if (newHearing.hearing.hasOwnProperty('hearingNotifiedDate')
        && !CheckEmptyOrWhitespace(newHearing.hearing.hearingNotifiedDate, 'date')) {
            if (newHearing.hearing.hearingNotifiedDate != null) {
                const str = newHearing.hearing.hearingNotifiedDate.toString();
                newHearing.hearing.notifiedDate = new Date(str.replace('T', ' '));
            }
        }

        if (newHearing.hearing.hasOwnProperty('hearingDecision')
        && !CheckEmptyOrWhitespace(newHearing.hearing.hearingDecision, 'string')) {
            if (newHearing.hearing.hearingDecision != null) {
                newHearing.hearing.originalHearingDecision = newHearing.hearing.hearingDecision;
            }
        } else {
            newHearing.hearing.originalHearingDecision = null;
            newHearing.hearing.hearingDecision = null;
        }
    } else {
        newHearing.hearing = new Hearing();
    }
    return newHearing;
}
